import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppComponent} from './app.component';
import {SharedModule} from './modules/shared/shared.module';
import {VideoModule} from './modules/video/video.module';
import {TimelineModule} from './modules/timeline/timeline.module';
import {RouterModule, Routes, UrlSegment} from '@angular/router';
import {RouterComponent} from './router.component';
import {FullscreenOverlayContainer, OverlayContainer} from '@angular/cdk/overlay';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {WarningBarComponent} from './modules/warning-bar/warning-bar.component';

export function playerRegion(segments) {
    if (segments.length >= 2 && segments[0].path.match(/^[a-z]{2}-[a-z]+-\d$/)) {
        return {
            consumed: segments,
            posParams: {
                region: new UrlSegment(segments[0].path, {
                }),
                videoId: new UrlSegment(segments[1].path, {
                }),
                dataUID: new UrlSegment(segments[2] ? segments[2].path : '', {
                })
            }
        };
    }

    return null;
}

const routes: Routes = [
    {
        path: ':videoId', redirectTo: ':videoId/', pathMatch: 'full'
    },
    {
        matcher: playerRegion, component: AppComponent
    },
    {
        path: ':videoId/:dataUID', component: AppComponent
    }
];

@NgModule({
    declarations: [
        RouterComponent,
        AppComponent,
        WarningBarComponent
    ],
    providers: [
        {
            provide: OverlayContainer, useClass: FullscreenOverlayContainer
        }
    ],
    imports: [
        BrowserModule,
        VideoModule,
        SharedModule,
        TimelineModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes, {
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            actionsBlocklist: [
                '[Video] - Video Frame Update',
                '[Video] - Begin Video Time Update',
                '[Video] - Video Time Update'
            ]
        })
    ],
    bootstrap: [RouterComponent]
})
export class AppModule {
}
